import { Offer } from 'src/common/types/models/Offer'
import Badge from 'src/common/ui-kit/Badge'
import { useMemo } from 'react'
import { getBadgesForOffer } from './utils'
import { activeTabAtom } from 'src/pages/DiscoverPage/discover-store'
import { useAtomValue } from 'jotai'

interface OfferBadgesProps {
  offer: Offer
  canceled?: boolean
}

const OfferBadges: React.FC<OfferBadgesProps> = ({ offer, canceled }) => {
  const activeTab = useAtomValue(activeTabAtom)

  const badges = useMemo(() => {
    return getBadgesForOffer(offer, activeTab)
  }, [activeTab, offer])

  return (
    <div className='flex space-x-1'>
      {canceled && (
        <Badge
          key={'canceled'}
          className='pointer-events-none'
          size='md'
          color='error'
          badgeType='status'
        >
          Canceled
        </Badge>
      )}
      {badges.map(({ color, label, type }) => (
        <Badge
          key={label}
          className='pointer-events-none'
          size='md'
          color={color}
          badgeType={type}
        >
          {label}
        </Badge>
      ))}
    </div>
  )
}

export default OfferBadges
